<div class="regwall-card">
  <div class="visual">
    <img class="wave" src="/wave.png" alt="" aria-hidden="true" loading="lazy" />
    <div class="visual-img-wrapper">
      <img
        class="visual-img"
        src="/welcomeV2.png"
        alt=""
        aria-hidden="true"
        loading="lazy"
        width="1102"
        height="639"
      />
    </div>
  </div>

  <div class="card-body">
    <h2 class="title">Triff bessere Entscheidungen</h2>
    <p class="subtitle">Analysiere jede Aktie in wenigen Minuten – 100% kostenfrei:</p>

    <div class="features">
      @if (responsive.isMobile()) {
        <ul class="features-list">
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span><strong>Kursbewegungen verstehen:</strong> relevante News auf einen Blick</span>
          </li>
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span><strong>Analystenurteile:</strong> Kursziele der Wall-Street-Elite</span>
          </li>
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span><strong>Zahlen &amp; Wettbewerb:</strong> Earnings, Scores, Peer-Vergleich</span>
          </li>
        </ul>
      } @else {
        <ul class="features-list">
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span
              ><strong>Kursbewegungen schneller verstehen:</strong> Relevante Meldungen auf einen
              Blick</span
            >
          </li>
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span
              ><strong>Einschätzungen der Wall-Street-Elite:</strong> Kursziele &amp; Thesen der
              Top-Analysten</span
            >
          </li>
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span
              ><strong>Earnings, Guidance &amp; Call:</strong> Erfahre sofort, worauf der Markt
              schaut</span
            >
          </li>
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span><strong>Fundamental Scores:</strong> KPIs einer Aktie kompakt bewertet</span>
          </li>
          <li class="feature-item">
            <img class="check-icon" src="/check.svg" alt="" aria-hidden="true" loading="lazy" />
            <span
              ><strong>Auf das richtige Pferd setzen:</strong> Vergleiche Aktien direkt mit ihren
              Wettbewerbern</span
            >
          </li>
        </ul>
      }
    </div>

    <button class="signup-btn" (click)="onSignup()">Jetzt kostenfrei anmelden</button>

    <p class="login-text">
      Bereits einen Account?
      <button type="button" class="login-link" (click)="onLogin()">Hier einloggen</button>
    </p>
  </div>
</div>
